/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module LogsModule */

import {
    Component,
    EventEmitter,
    Inject,
    Output,
} from '@angular/core';

import { e2eTimingGroupByKeys } from 'ng/modules/logs/constants/logs-signpost.constants';
import { StateParams } from '@uirouter/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';
import {
    TrafficLogsSignpostStore,
} from 'ng/modules/logs/components/traffic-logs/traffic-logs-sidebar/traffic-logs-signpost.store';
import './logs-signpost-custom-e2e-timing-header.component.less';
import {
    ITrafficLogsStates,
    IVsConfigForTrafficLogs,
    TrafficLogsStore,
} from 'ng/modules/logs/components/traffic-logs/traffic-logs.store';
import * as l10n from './logs-signpost-custom-e2e-timing-header.l10n';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component for log signpost e2e timing header section.
 * @author Suraj Kumar, Yogesh Patil
 */
@Component({
    selector: 'logs-signpost-custom-e2e-timing-header',
    templateUrl: './logs-signpost-custom-e2e-timing-header.component.html',
})
export class LogsSignpostCustomEndToEndTimingHeaderComponent {
    /**
     * Event emitter to indicate a switch to specified data view.
     */
    @Output()
    public onSwitchView = new EventEmitter<string>();

    /**
     * Hold all allowed keys for grouping e2e logs.
     */
    public readonly e2eTimingGroupByKeys = e2eTimingGroupByKeys;

    /**
     * Property holding e2e timing logs groupby key value.
     */
    public isFilteredBy = e2eTimingGroupByKeys.totalTime;

    /**
     * Hold the virtual service configuration settings for traffic logs.
     */
    public vs: IVsConfigForTrafficLogs;

    public readonly globalL10nKeys = globalL10nKeys;

    public readonly l10nKeys = l10nKeys;

    constructor(
        public readonly trafficLogsSignpostStore: TrafficLogsSignpostStore,
        @Inject('$stateParams')
        public readonly $stateParams: StateParams,
        private readonly l10nService: L10nService,
        public readonly trafficLogsStore: TrafficLogsStore<ITrafficLogsStates>,
    ) {
        this.l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Emit event to switch view to specified field.
     */
    public switchView(key: string): void {
        this.isFilteredBy = key;
        this.onSwitchView.emit(key);
    }
}
